<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qEQCcR/tc-custom/9781504007184.jpg?1706790615807" alt="This image is the cover for the book Wylding Hall"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Wylding Hall
      </h1>
      <p class="bookDescription body article font2">
        <b>This Shirley Jackson Award–winning novel is “a true surreal phantasmagoria . . . [a] gothic supernatural” horror story set in the decadent world of British rock (Chelsea Quinn Yarbro).</b><br/><br/> When the young members of a British acid-folk band are compelled by their manager to record their unique music, they hole up at Wylding Hall, an ancient country house with dark secrets. There they create the album that will make their reputation, but at a terrifying cost: Julian Blake, the group’s lead singer, disappears within the mansion and is never seen or heard from again.<br/><br/> Now, years later, the surviving musicians, along with their friends and lovers—including a psychic, a photographer, and the band’s manager—meet with a young documentary filmmaker to tell their own versions of what happened that summer. But whose story is true? And what really happened to Julian Blake?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Elizabeth Hand
      </h2>
      
      <p class="authorDescription body article">Elizabeth Hand is the author of sixteen multiple-award-winning novels and six collections of short fiction. She is a longtime reviewer for numerous publications, including the <I>Washington Post</I>, the <I>Los Angeles Times</I>, and the <I>Magazine of Fantasy &amp; Science Fiction</I>. Her noir novels featuring punk photographer Cass Neary have been compared to the work of Patricia Highsmith and optioned for a TV series. Hand teaches at the Stonecoast MFA Program in Creative Writing and, when not living under pandemic conditions, divides her time between the Maine coast and North London.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1362b1ae